import marker from "../../Images/marker.svg";
import directionSVG from "../../Images/directions.svg";
import React from "react";

export default ({ name, address, link, showCard, setShowCard }) => {
    return (<div style={{zIndex: showCard?1:0, position: "absolute"}}>
        <img src={marker} alt="" onClick={() => { setShowCard(!showCard) }}/>
        {showCard &&
            <div className="flex flex-col bg-white w-64 p-4 gap-1">
                <div className="font-bold text-sm">
                    {name}
                </div>
                <a href={link} target="_blank" className="underline flex gap-1">
                    <img src={directionSVG} alt="dir"/> {address}
                </a>
            </div>
        }
    </div>);
}